import FragmentPage from '../core/FragmentPage';

export default class GaleriaPage extends FragmentPage {
  constructor(meta) {
    super('galeria', meta, { contentFile: 'galeria.php' });
    this.galleryElement = null;
    this.modalElement = null;
    this.modalImageElement = null;
    this.closeTimer = null;

    this.handleGalleryClick = this.handleGalleryClick.bind(this);
    this.handleModalClick = this.handleModalClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  async onEnter(context) {
    if (!context.content.querySelector('.grid-gallery')) {
      return;
    }

    this.galleryElement = context.content;
    this.ensureModal();
    this.galleryElement.addEventListener('click', this.handleGalleryClick);
    document.addEventListener('keydown', this.handleKeyDown);
  }

  async onLeave() {
    if (this.galleryElement) {
      this.galleryElement.removeEventListener('click', this.handleGalleryClick);
      this.galleryElement = null;
    }

    document.removeEventListener('keydown', this.handleKeyDown);
    this.destroyModal();
  }

  ensureModal() {
    if (this.modalElement) {
      return;
    }

    const modal = document.createElement('div');
    modal.className = 'gallery-modal';
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = `
      <div class="gallery-modal__backdrop"></div>
      <div class="gallery-modal__frame">
        <img class="gallery-modal__image" src="" alt="">
      </div>
    `;

    modal.addEventListener('click', this.handleModalClick);
    document.body.appendChild(modal);

    this.modalElement = modal;
    this.modalImageElement = modal.querySelector('.gallery-modal__image');
  }

  destroyModal() {
    if (this.closeTimer) {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    document.body.classList.remove('gallery-modal-open');

    if (!this.modalElement) {
      return;
    }

    this.modalElement.removeEventListener('click', this.handleModalClick);
    this.modalElement.remove();
    this.modalElement = null;
    this.modalImageElement = null;
  }

  handleGalleryClick(event) {
    const item = event.target.closest('.grid-gallery__item');
    if (!item) {
      return;
    }

    const image = item.querySelector('.grid-gallery__image');
    if (!image) {
      return;
    }

    event.preventDefault();
    this.openModal(image);
  }

  handleModalClick() {
    this.closeModal();
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.closeModal();
    }
  }

  openModal(image) {
    this.ensureModal();
    if (!this.modalElement || !this.modalImageElement) {
      return;
    }

    if (this.closeTimer) {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    const medSrc  = image.currentSrc || image.src;
    const highSrc = image.dataset.highSrc || medSrc;

    this.modalImageElement.src = medSrc;
    this.modalImageElement.alt = image.alt || '';
    this.modalElement.hidden = false;
    this.modalElement.setAttribute('aria-hidden', 'false');
    this.modalElement.classList.add('is-loading');
    document.body.classList.add('gallery-modal-open');

    window.requestAnimationFrame(() => {
      if (this.modalElement) {
        this.modalElement.classList.add('is-visible');
      }
    });

    if (highSrc && highSrc !== medSrc) {
      const hires = new Image();
      hires.onload = () => {
        if (this.modalImageElement && this.modalElement) {
          this.modalImageElement.src = highSrc;
          this.modalElement.classList.remove('is-loading');
        }
      };
      hires.onerror = () => {
        if (this.modalElement) {
          this.modalElement.classList.remove('is-loading');
        }
      };
      hires.src = highSrc;
    } else {
      this.modalElement.classList.remove('is-loading');
    }
  }

  closeModal(options = {}) {
    const { immediate = false } = options;

    if (!this.modalElement) {
      return;
    }

    if (this.closeTimer) {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    const finishClose = () => {
      if (!this.modalElement || !this.modalImageElement) {
        return;
      }

      this.modalElement.hidden = true;
      this.modalImageElement.removeAttribute('src');
      this.modalElement.setAttribute('aria-hidden', 'true');
      this.modalElement.classList.remove('is-loading');
    };

    this.modalElement.classList.remove('is-visible');
    document.body.classList.remove('gallery-modal-open');

    if (immediate) {
      finishClose();
      return;
    }

    this.closeTimer = window.setTimeout(() => {
      finishClose();
      this.closeTimer = null;
    }, 320);
  }
}
